import { Trans } from '@lingui/react';
import { Button } from '@startuptools/ui/Button';
import { Checkbox } from '@startuptools/ui/Checkbox';
import { Card } from '@startuptools/ui/Card';
import { CardContent } from '@startuptools/ui/CardContent';
import { Alert } from '@startuptools/ui/Alert';
import { Box } from '@startuptools/ui/Box';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { Link } from '@startuptools/ui/Link';

export const ShareCertificatesWarning = ({
  onCheckboxChange,
  onButtonClick,
  isChecked,
}: {
  onCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onButtonClick: () => void;
  isChecked: boolean;
}) => {
  return (
    <Card variant="outlined">
      <CardContent>
        <Alert variant="outlined" color="warning" sx={{ marginBottom: 2 }}>
          <Stack>
            <Typography level="title-lg">
              <Trans id="Are you sure you want to open up the possibility to issue share certificates?" />
            </Typography>
            <Box>
              <Trans
                id="There are many good reasons not to issue share certificates. We have summarized them in <link>this article</link>. While avoiding share certificates is often the best choice, there are cases where share certificates are the right solution or even necessary."
                components={{
                  link: (
                    <Link href="https://startuptools.org/se/darfor-ska-du-inte-ha-aktiebrev-anvand-en-saker-synkroniserad-aktiebok-i-molnet-istallet/ " />
                  ),
                }}
              />
            </Box>
          </Stack>
        </Alert>
        <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Checkbox checked={isChecked} onChange={onCheckboxChange} sx={{ mr: 2 }} />
            <Typography>
              <Trans id="Yes, I am sure." />
            </Typography>
          </Box>
          <Button disabled={!isChecked} onClick={onButtonClick}>
            <Trans id="Create share certificates" />
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
